import { Organization } from "./organization";

export type SuccessAuthResponseData = {
  access_token: string;
  token_type: string;
  refresh_token: string;
  expires_in: number;
  scope: string;
  id_token: string;
};
export type SuccessChallengeResponeData = {
  id?: string;
  challenge_id?: string;
};
export type SuccessMfaResponseData = {
  access_token: string;
  expiry: number;
};
export type ErrorData = {
  code: number;
  text: string;
};

export type ErrorResponseData = {
  errors: ErrorData[];
};

export type Response = {
  success?: boolean;
  data?:
    | SuccessAuthResponseData
    | SuccessChallengeResponeData
    | SuccessMfaResponseData;
  errors?: ErrorData[];
};
export type OtpResponse = {
  success: boolean;
  data?: {
    id: string;
    is_new_user: boolean;
    factors?: object;
    expiry?: Record<string, string>;
  };
  errors?: ErrorData[];
};

export interface ProviderConfig {
  provider: string;
  domain: string | null;
}

export interface ProviderCreds {
  category: string;
  organization?: Organization;
  config: Record<string, string>;
}

export interface ChallengeConfig {
  channel?: ChannelEnum;
  category: string;
  organization: Organization;
  config: {
    email?: string;
    phone?: string;
  };
}

export interface Provider {
  provider: string;
  providerConfig?: ProviderConfig;
  login(creds: ProviderCreds, baseURL: string): Promise<Response>;
  send_otp?(creds: ChallengeConfig, baseURL: string): Promise<OtpResponse>;
}

//Email Provider
export type EmailProviderConfig = ProviderConfig;

export interface EmailProviderCreds extends ProviderCreds {
  challenge: {
    id: string;
    password: string;
  };
  config: {
    email: string;
    password: string;
  };
}

//LDAP Provider
export type LDAPProviderConfig = ProviderConfig;

export interface LDAPProviderCreds extends ProviderCreds {
  config: {
    username: string;
    password: string;
  };
  organization: Organization;
}

//Google Provider
export type GoogleProviderConfig = ProviderConfig;

export interface GoogleProviderCreds extends ProviderCreds {
  meta: Record<string, string | number>;
  config: {
    id_token: string;
  };
}

//PhoneOtp
export type PhoneOtpProviderConfig = ProviderConfig;

//EmailOtp
export type EmailOtpProviderConfig = ProviderConfig;

export interface OtpProviderCreds extends ProviderCreds {
  challenge: {
    id: string;
    code: string;
  };
  config: {
    email?: string;
    phone?: string;
  };
}

export enum ProvidersEnum {
  EmailProvider = "emailProvider",
  LDAPProvider = "ldapProvider",
  GoogleOAuthProvider = "googleOAuthProvider",
  EmailOtpProvider = "emailOtpProvider",
  PhoneOtpProvider = "phoneOtpProvider"
}

//join Factors and Channel
export enum ConfigEnum {
  Email = "email",
  Phone = "phone",
  Google = "google",
  Apple = "apple",
  Aletheia = "aletheia",
  Oauth2 = "oauth2",
  Otp = "otp",
  Password = "password",
  Totp = "totp",
  Code = "code",
  Secret = "secret",
  Id_Token = "id_token",
  Username = "username"
}

export enum ChannelEnum {
  Email = "email",
  Phone = "phone",
  Google = "google",
  Apple = "apple",
  Aletheia = "aletheia",
  OAUTH2 = "oauth2"
}

export enum ChannelConfigEnum {
  Google = "id_token",
  Apple = "id_token",
  Username = "username",
  Password = "password",
  Email = "email",
  Phone = "phone"
}

export type ChannelInterface = {
  [key in ChannelEnum]?: string;
};

export enum FactorsEnum {
  OTP = "otp",
  Password = "password",
  TOTP = "totp",
  GOOGLE = "google",
  APPLE = "apple"
}

export enum ScopeEnum {
  CreateSesion = "auth.session:create",
  CreateAccount = "auth.account:create",
  PhoneMerge = "auth.accounts:phone:merge",
  EmailMerge = "auth.accounts:email:merge"
}

export enum CategoryEnum {
  Employee = "employee",
  User = "user"
}
